import store from '@/store/index'
import jwt from 'jsonwebtoken'

/**
 * @description 메징idx와 accessToken을 겡신
 * @returns {Boolean}
 */
export function renewalLoginStatus () {
  // 매장idx backup
  store.commit('setStoreIdx', store.getters.getStoreIdx)
  // accessToken backup
  store.commit('setAccessToken', store.getters.getAccessToken)
  // store에 accessToken없을때
}

/**
 * @description 로그인 상태 확인
 * @returns {Boolean}
 */
export function isValidLoginStatus () {
  return hasStoreIdx() && hasAccessToken()
}

/**
 * @description 매장의 idx 존재 여부 반환
 * @returns {Boolean}
 */
export function hasStoreIdx () {
  return (store.getters.getStoreIdx > 0)
}

/**
 * @description accessToken의 존재 여부 반환
 * @returns {Boolean}
 */
export function hasAccessToken () {
  return (store.getters.getAccessToken && store.getters.getAccessToken.length > 0)
}

/**
 * @description accessToken의 만료 여부 반환
 * @returns {Boolean}
 */
export function isVaildAccessToken () {
  const decoded = jwt.decode(store.getters.getAccessToken.replace('Bearer ', ''))
  return (decoded && decoded.exp && (new Date().getTime() > (decoded.exp * 1000)))
}

// 기본적인 이메일 양식 검증 (TB-7894)
// 로컬/도메인 구분, 도메인 라벨 사이 연속 점(aaaa..com) 및 최상위 도메인 누락을 걸러낸다.
const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/

/**
 * @description 이메일 양식 유효 여부 반환
 * @param {string} email - 앞뒤 공백이 제거된 이메일
 * @returns {Boolean}
 */
export function isValidEmail (email) {
  return typeof email === 'string' && EMAIL_REGEX.test(email)
}
